import { createI18n } from 'vue-i18n'
import uz from './locales/uz.json'
import ru from './locales/ru.json'

/**
 * Uzbek and Russian, chosen by the user. Uzbek is the default.
 *
 * mdm-service translates its error messages into the same two languages; the API
 * client sends the chosen one as Accept-Language.
 */
export const SUPPORTED_LOCALES = ['uz', 'ru'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]

const STORAGE_KEY = 'mdm.locale'

function initialLocale(): Locale {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored && SUPPORTED_LOCALES.includes(stored as Locale)) {
    return stored as Locale
  }
  const browser = navigator.language.slice(0, 2)
  return SUPPORTED_LOCALES.includes(browser as Locale) ? (browser as Locale) : 'uz'
}

export const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: 'uz',
  messages: { uz, ru },
})

export function setLocale(locale: Locale): void {
  i18n.global.locale.value = locale
  localStorage.setItem(STORAGE_KEY, locale)
  document.documentElement.lang = locale
}
